import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 70h80v100H60z" }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M60 82h80v8H60zM60 152h80v8H60z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "6",
      d: "M100 70q10-20 30-20t20-20"
    }, null, -1),
    _createElementVNode("path", { d: "m148 18 10 12-8 12-8-12z" }, null, -1)
  ]))]))
}
export default { render: render }